import { createContext } from 'react'

export const AxiosSetUpContext = createContext()
